<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 53 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.20017 30.0534L18.1343 13.5713C20.2064 14.9535 23.0324 14.7303 24.861 12.9017C26.655 11.1077 26.9038 8.3536 25.6072 6.29335L30.5184 1.51254C32.0863 -0.0138198 34.5897 0.002995 36.137 1.55027L51.2214 16.6347C52.7835 18.1968 52.7835 20.7295 51.2214 22.2916L51.1831 22.3293L46.2951 27.0874C44.2678 25.9672 41.6657 26.2669 39.9459 27.9867C38.2622 29.6704 37.9396 32.1999 38.9782 34.2078L21.865 50.8702C20.297 52.3965 17.7936 52.3797 16.2464 50.8324L1.16192 35.748C-0.400174 34.1859 -0.400174 31.6533 1.16192 30.0912L1.20017 30.0534ZM35.2718 23.2332C34.4274 24.0487 34.4604 25.2914 35.1733 26.0413C36.0528 26.9663 37.2473 26.8304 37.991 26.1657C38.9193 25.3359 38.8231 23.9711 38.0334 23.2482C37.2884 22.4613 35.9799 22.5494 35.2718 23.2332ZM31.0457 19.0864C30.22 19.8942 30.237 21.0918 30.9479 21.8655C31.7953 22.7878 33.0143 22.6926 33.7902 21.9944C34.6958 21.1795 34.6128 19.8171 33.8235 19.0894C33.0538 18.2928 31.7662 18.3814 31.0457 19.0864ZM26.7762 14.7582C25.9689 15.54 25.9107 16.8827 26.8522 17.7154C27.6551 18.4255 28.7813 18.3476 29.513 17.675C30.4407 16.8222 30.3287 15.507 29.5594 14.7725C28.7813 13.9551 27.4659 14.0902 26.7762 14.7582Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
